export default __webpack_public_path__ + "img/logo-onecbm.797cd25d.png";